<template>
  <div class="minidiv">
    <b-modal
      :id="'modal-remove_' + sn"
      centered
      title="Confirm remove"
      ok
      ok-variant="success"
      cancel-variant="danger"
      @ok="deletePartnership()"
    >
      <template v-slot:modal-ok> Yes, Remove </template>
      <p>
        Are You sure you want to remove {{ partnership.title }} as an Admin??
      </p>
    </b-modal>
    <div class="flex-parent text-center pt-1">
      <p class="flex-child">{{ sn + (page - 1) * interval }}</p>
      <p class="flex-child">
        <b-link
          :to="{
            name: 'editpartnership',
            params: { trackid: partnership.trackid }
          }"
          >{{ partnership.title }}</b-link
        >
      </p>
      <p class="flex-child">{{ partnership.organization }}</p>
      <p class="flex-child">{{ partnership.code }}</p>
      <p class="flex-child">{{ partnership.share }}</p>
      <p class="flex-child">{{ partnership.users }}</p>
      <p class="flex-child">{{ partnership.earnings }}</p>
      <p class="flex-child">{{ partnership.upgrades }}</p>
      <p>
        <b-button
          :disabled="partnership.clearance == 'Org Super Admin'"
          class="p-1 list-button"
          variant="danger"
          @click="comfirmDelete()"
          >Delete</b-button
        >
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: ["partnership", "sn", "page", "interval"],
  data() {
    return {
      overallscore: 0
    };
  },
  created() {},
  methods: {
    ...mapActions("admin", ["delPartnership", "fetchPartnerships"]),
    comfirmDelete() {
      this.$bvModal.show(`modal-remove_${this.sn}`);
    },
    deletePartnership() {
      let partnerObj = {
        trackid: this.partnership.trackid
      };

      return this.delPartnership(partnerObj).then(() => {
        this.fetchPartnerships();
        // console.log(response)
      });
    }
  },
  computed: {
    ...mapState({
      allinstitutions: state => state.admin.listinstitutions,
      details: state => state.loginmaster.details
    })
  }
};
</script>

<style scoped>
.minidiv {
  border-radius: 10px 10px;
  background-color: white;
}

.rins {
  font-size: 0.75rem;
}

.lowscore {
  color: red;
}

.highscore {
  color: #00377b;
}

.totsco {
  color: #00377b;
  font-weight: bolder;
}

.brel {
  text-decoration: none;
  color: black;
}
.link-sol {
  text-decoration: none;
  color: #00984a;
}

.flex-parent {
  display: flex;
  flex-flow: row nowrap;
  /* height: 35px; */
}

.flex-child {
  width: 130px;
  overflow-x: auto;
  margin-right: 2px;
  scrollbar-width: thin;
}
@media screen and (max-width: 768px) {
  .flex-child {
    font-size: 0.6rem;
  }
  .link-sol {
    font-size: 0.7rem;
  }
  .list-button {
    width: contain;
    font-size: 0.6rem;
    padding: 3px;
  }
}
</style>
